import React, { Component, Fragment } from "react";
import { Menu, Popup, Button, Icon } from "semantic-ui-react";
import { PropTypes } from "prop-types";
import CustomFieldConfirmModal from '../../Pages/CustomFields/CustomFieldConfirmModal';

class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: "Manage Users",
      showClose: this.props.showClose
    };
  }

  handleItemClick = (e, { name, url }) => url ? window.open(url, "_self") : this.setState({ activeItem: name });

  render() {
    // console.log("Props : ", this.props);

      const { activeItem } = this.state.activeItem;
      const activeStyle = 'color-wk-primary-blue font-weight: bold active';
    // console.log("#################", this.props.subHeaderMenuItems)
    if (this.props.subHeaderMenuItems) {
      const subHeaderList = this.props.subHeaderMenuItems.map(item => {
        return (
          <Menu.Item
            key={item.name}
            name={item.name}
                url={item.url}
                active={this.state.activeItem === item.name ? activeStyle : ""}
            onClick={this.handleItemClick}
          />
        );
      });



      const helpMenuList = this.props.helpMenuItems.map(item => {
        return (

          <Popup
            key={item.name}
            content={item.url ? item.name : 'Coming Soon'}
            position={item.position}
            trigger={<Menu.Item key={item.name} as="a"
                onClick={item.url == "Help URL" ? () => window.open("http://support.cch.com/#tab-7/", item.name, 'top=30,left=250,height=' + (window.screen.height * 0.9) + ', width=' + (window.screen.width * 0.9), 'status=yes,scrollbars=yes,resizable=yes')
                    : item.url == "Video URL" ? () => window.open("http://support.cch.com/videolibrary/#/", item.name, 'top=30,left=250,height=' + (window.screen.height * 0.9) + ', width=' + (window.screen.width * 0.9), 'status=yes,scrollbars=yes,resizable=yes')
                        : item.url ? () => window.open(window.routemap + item.url, item.name, 'top=30,left=250,height=' + (window.screen.height * 0.9) + ', width=' + (window.screen.width * 0.9), 'status=yes,scrollbars=yes,resizable=yes')
                            : () => false} >
                {item.name}</Menu.Item>} />
        );
      });

      return (
        <Fragment>
          <Menu className='sub' pointing secondary>
            {/* <Menu.Item
                            name="Manage Users"
                            active={activeItem === "Manage Users"}
                            onClick={this.handleItemClick}
                        />
                        <Menu.Item
                            name="User Group Rights"
                            active={activeItem === "User Group Rights"}
                            onClick={this.handleItemClick}
                        /> */}
            {subHeaderList}

            <Menu.Menu position="right">
              {helpMenuList}
              {/*
              <Popup content='Coming Soon' position='bottom left' trigger={<Menu.Item as="a" >Help</Menu.Item>} />
              <Popup content='Coming Soon' position='bottom center' trigger={<Menu.Item as="a" >Video</Menu.Item>} />
              <Popup content='User Guide' position='bottom right' trigger={<Menu.Item as="a" onClick={() => window.open(window.routemap + 'xcmhelp/help/index.html#!Documents/manageusers.htm', 'Help', 'top=30,left=250,height=' + (window.screen.height * 0.9) + ', width=' + (window.screen.width * 0.9), 'status=yes,scrollbars=yes,resizable=yes')}>User Guide</Menu.Item>} />
             */ } {this.state.showClose ?
                <CustomFieldConfirmModal />
                : ""
              }

            </Menu.Menu>
          </Menu>
        </Fragment>
      );
    } else {
      return (
        <div>
          <h2>Sub Header module is'nt working properly</h2>
        </div>
      );
    }
  }
}

SubHeader.propTypes = {
  subHeaderMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string
    })
  ),
  helpMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      position: PropTypes.string
    })
  )
};

export default SubHeader;
